import { Button } from "../../../../buttons/button";
import { InformationCard } from "../../../../cards/infoCard";

export const StepOne = ({ onSuccess }: { onSuccess: () => void }) => {
  return (
    <div className="flex flex-col justify-between">
      <InformationCard
        info={
          <p>
            <span className="text-info-purple font-bold">
              Reminder: Keeping enough funds for your cooperative's operations
              such as loan disbursements is essential.
            </span>
            <br /> <br />
            <span>
              This withdrawal might leave insufficient funds in your Thriftcorp
              account. You might be required to fund your account in the future.
            </span>
          </p>
        }
        innerClassName="!items-start md:!min-w-full"
        hasIcon
        variant="purple"
        size="mini"
      />

      <Button
        type="button"
        className=""
        text="Proceed"
        onClick={() => {
          onSuccess();
        }}
      />
    </div>
  );
};
